import Dashboard from '../../../views/corp/dashboard/Dashboard'

const dashboardRoutes = [
  {
    path: '/corp/dashboard',
    element: <Dashboard />
  }
];

export default dashboardRoutes;
